import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  padding: 8px 0;
  border: 1px solid #c9c4b6;
  border-left: 0;
  border-right: 0;
  color: ${colors.darkGray};

  @media (min-width: 768px) {
    padding: 8px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  @media (max-width: 1280px) and (max-width: 768px) {
    margin-top: 27px !important;
    padding: 24px;
  }

  .container-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .doc-found-marge {
    padding-left: 10px;
    padding-right: 10px;
  }

  & .doc-found {
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;

    @media (max-width: 1024px) {
      text-align: center;
      margin-top: 10px;
      margin-bottom: 15px;
      margin-left: 0px;
      margin-right: 0px;
    }

    input {
      text-align: center;
      border: 1px solid ${colors.tangerine};
      width: 56px;
      height: 27px;
      margin: 8px;
      background: transparent;
    }
  }

  .change-page {
    cursor: pointer;

    path {
      stroke: ${colors.iconOrange};
    }

    @media not all and (pointer: coarse) {
      &:hover {
        path {
          stroke: black;
        }
      }
    }
  }

  .icon--disabled {
    path {
      stroke: ${colors.gray};
    }

    cursor: not-allowed;
  }

  .select {
    min-width: 235px;
    width: 100%;

    @media (max-width: 1024px) {
      min-width: 200px;
    }
  }

  .select2 {
    min-width: 200px;
  }

  .rotate-icon {
    transform: rotate(180deg);
  }

  & .navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;

    @media (max-width: 767px) {
      margin: 0 auto;
    }
  }
`;

const svgStyle = {
  width: 32,
  color: colors.gray
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/components/PaginationResults/style.js